<template>
	<b-row class="match-height">
		<b-col v-for="(card, idx) in cards" :key="idx" md="4" lg="2">
			<b-card no-body class="text-center">
				<b-card-body>
					<b-avatar :variant="card.variant" size="40" class="mb-1">
						<feather-icon :icon="card.icon" size="18" />
					</b-avatar>
					<h3 class="mb-25">{{ formatNb(card.value) }}</h3>
					<small class="text-muted">{{ card.label }}</small>
				</b-card-body>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BAvatar } from 'bootstrap-vue'

export default {
	components: { BRow, BCol, BCard, BCardBody, BAvatar },
	props: {
		cuis: { type: String, default: '' },
	},
	data() {
		return {
			loading: false,
			kpi: {
				leads_30d: 0,
				reservations_30d: 0,
				wp_sites_actifs_7d: 0,
				magiclinks_envoyes_30d: 0,
				magiclinks_consommes_30d: 0,
				clients_uniques_login_30d: 0,
			},
		}
	},
	computed: {
		cards() {
			return [
				{ label: 'Leads 30j', value: this.kpi.leads_30d, icon: 'TargetIcon', variant: 'light-info' },
				{ label: 'Réservations 30j', value: this.kpi.reservations_30d, icon: 'ShoppingBagIcon', variant: 'light-success' },
				{ label: 'Sites WP actifs 7j', value: this.kpi.wp_sites_actifs_7d, icon: 'GlobeIcon', variant: 'light-primary' },
				{ label: 'Magic links envoyés 30j', value: this.kpi.magiclinks_envoyes_30d, icon: 'SendIcon', variant: 'light-warning' },
				{ label: 'Magic links consommés 30j', value: this.kpi.magiclinks_consommes_30d, icon: 'CheckCircleIcon', variant: 'light-success' },
				{ label: 'Clients connectés 30j', value: this.kpi.clients_uniques_login_30d, icon: 'UserCheckIcon', variant: 'light-info' },
			]
		},
	},
	created() { this.load() },
	methods: {
		formatNb(n) { return (n || 0).toLocaleString('fr-FR') },
		load() {
			this.loading = true
			const url = `/admin/stats-clients/overview${this.cuis ? `?CUIS=${encodeURIComponent(this.cuis)}` : ''}`
			this.$http.get(url)
				.then(response => {
					this.loading = false
					if (response.data && response.data.res === 1) {
						this.kpi = response.data.kpi || this.kpi
					}
				})
				.catch(() => { this.loading = false })
		},
	},
}
</script>
